var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallClockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0701 13.4847C19.0701 13.4297 19.0801 13.3797 19.0801 13.3247C19.0801 11.4597 18.4101 9.74469 17.2951 8.41469L18.3051 7.40469L19.3651 8.46469L20.0701 7.75969L17.2401 4.92969L16.5351 5.63469L17.5951 6.69469L16.5951 7.69469C15.3801 6.57469 13.8101 5.83469 12.0701 5.68469V4.42969H13.5701V3.42969H9.57007V4.42969H11.0701V5.66969C9.28007 5.74469 7.65007 6.43469 6.38507 7.53469L5.54507 6.69469L6.60507 5.63469L5.90007 4.92969L3.07007 7.75969L3.77507 8.46469L4.83507 7.40469L5.67007 8.23969C4.46507 9.59469 3.72507 11.3747 3.72507 13.3247C3.72507 17.5547 7.16507 20.9997 11.4001 20.9997V19.9997C7.72007 19.9997 4.72507 17.0047 4.72507 13.3247C4.72507 9.64469 7.72007 6.64969 11.4001 6.64969C15.0801 6.64969 18.0751 9.64469 18.0751 13.3247C18.0751 13.3797 18.0651 13.4297 18.0651 13.4847H16.1401L18.5751 17.4647L21.0101 13.4847H19.0701Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.2494H7.71997V14.2494H12.25V8.10938H11.25V13.2494Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallClockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wall_Clock_icon.f8e3686f8b5996e173b7cbdd5f354965.svg";